import React from "react";

export default function EditIcon({ color = "#fff", ...restProps }) {
  return (
    <svg
      version="1.1"
      id="EditIcon"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 60 60"
      style={{ enableBackground: "new 0 0 60 60" }}
      xmlSpace="preserve"
      width={60}
      height={60}
      {...restProps}
    >
      <g>
        <path
          d="M36.719,22h-25c-0.552,0-1,0.448-1,1s0.448,1,1,1h25c0.552,0,1-0.448,1-1S37.271,22,36.719,22z"
          fill={color}
        />
        <path
          d="M11.719,16h10c0.552,0,1-0.448,1-1s-0.448-1-1-1h-10c-0.552,0-1,0.448-1,1S11.167,16,11.719,16z"
          fill={color}
        />
        <path
          d="M36.719,30h-25c-0.552,0-1,0.448-1,1s0.448,1,1,1h25c0.552,0,1-0.448,1-1S37.271,30,36.719,30z"
          fill={color}
        />
        <path
          d="M28.719,38h-17c-0.552,0-1,0.448-1,1s0.448,1,1,1h17c0.552,0,1-0.448,1-1S29.271,38,28.719,38z"
          fill={color}
        />
        <path
          d="M25.719,48c0.552,0,1-0.448,1-1s-0.448-1-1-1h-14c-0.552,0-1,0.448-1,1s0.448,1,1,1H25.719z"
          fill={color}
        />
        <path
          d="M2.719,2h29v14h14v18h2V14.586L33.133,0H0.719v60h29v-2h-27V2z M33.719,3.414L44.305,14H33.719V3.414z"
          fill={color}
        />
        <path
          d="M58.407,37.162l-2.849-2.85c-1.128-1.128-3.094-1.128-4.222,0l-15.391,15.39l-2.121,7.779L33.305,58
            c-0.388,0.388-0.389,1.014-0.006,1.405l-0.005,0.02l0.02-0.005c0.194,0.19,0.446,0.287,0.698,0.287
            c0.256,0,0.512-0.098,0.707-0.293l0.519-0.519l7.779-2.121l15.39-15.391c0.564-0.564,0.875-1.313,0.875-2.111
            S58.971,37.725,58.407,37.162z M38.254,50.222l10.243-10.243l4.243,4.243L42.497,54.465L38.254,50.222z M37.351,52.147l3.22,3.22
            l-4.427,1.207L37.351,52.147z M56.993,39.969l-2.839,2.839l-4.243-4.243l2.839-2.839c0.372-0.372,1.021-0.373,1.393,0l2.85,2.85
            c0.186,0.186,0.289,0.433,0.289,0.696C57.281,39.535,57.179,39.783,56.993,39.969z"
          fill={color}
        />
      </g>
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
      <g />
    </svg>
  );
}
